var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M24.2713 9.72L21.3413 8.09C21.1413 7.66 20.9013 7.25 20.6313 6.86L20.6913 3.5C19.4513 2.37 17.9713 1.52 16.3713 1.01L13.4913 2.73C13.0213 2.7 12.5413 2.7 12.0613 2.73L9.17126 1C7.57126 1.52 6.10126 2.37 4.86126 3.5L4.92126 6.86C4.64126 7.25 4.40126 7.66 4.20126 8.09L1.26126 9.72C0.911263 11.36 0.911263 13.06 1.27126 14.7L4.20126 16.33C4.40126 16.76 4.64126 17.18 4.91126 17.58L4.85126 20.93C6.09126 22.06 7.57126 22.91 9.17126 23.42L12.0513 21.7C12.5213 21.73 13.0013 21.73 13.4813 21.7L16.3713 23.43C17.9713 22.91 19.4413 22.06 20.6813 20.93L20.6213 17.57C20.8913 17.18 21.1313 16.77 21.3313 16.34L24.2713 14.71C24.6413 13.06 24.6413 11.36 24.2713 9.72ZM12.7713 17.65C9.77126 17.65 7.34126 15.22 7.34126 12.22C7.34126 9.22 9.77126 6.79 12.7713 6.79C15.7713 6.79 18.2013 9.22 18.2013 12.22C18.2013 15.22 15.7713 17.65 12.7713 17.65Z",
    fill: "#91BC68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7718 17.6398C15.7707 17.6398 18.2018 15.2087 18.2018 12.2098C18.2018 9.21088 15.7707 6.77979 12.7718 6.77979C9.77289 6.77979 7.3418 9.21088 7.3418 12.2098C7.3418 15.2087 9.77289 17.6398 12.7718 17.6398Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6213 6.86C20.8913 7.25 21.1313 7.66 21.3313 8.09L24.2613 9.72C24.6313 11.36 24.6313 13.06 24.2713 14.7L21.3313 16.33C21.1313 16.76 20.8913 17.17 20.6213 17.56L20.6813 20.92C19.4413 22.05 17.9713 22.91 16.3713 23.42L13.4813 21.69C13.0113 21.72 12.5313 21.72 12.0513 21.69L9.17126 23.41C7.57126 22.9 6.09126 22.05 4.85126 20.92L4.91126 17.57C4.64126 17.17 4.40126 16.76 4.20126 16.32L1.27126 14.69C0.911263 13.05 0.911263 11.35 1.26126 9.71L4.20126 8.09C4.40126 7.66 4.64126 7.25 4.91126 6.86L4.86126 3.5C6.10126 2.37 7.57126 1.51 9.17126 1L12.0613 2.73C12.5313 2.7 13.0113 2.7 13.4913 2.73L16.3713 1.01C17.9713 1.52 19.4513 2.37 20.6913 3.5L20.6213 6.86Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.189dab58fe75bb72d08854b4323017ac.svg";
export { ForwardRef as ReactComponent };